var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout",
    { staticClass: "ai-assistant__wrapper" },
    [
      _c(
        "a-layout-header",
        [
          _c(
            "div",
            { staticClass: "ai-assistant__header__main" },
            [
              _c("div", { staticClass: "ai-assistant__header__title" }, [
                _vm._v(
                  _vm._s((_vm.userAgent && _vm.userAgent.agent_name) || "--")
                ),
              ]),
              _c("a-space", { staticClass: "ai-assistant__header__info" }, [
                _c("span", [
                  _vm._v(
                    "最后更新时间：" +
                      _vm._s((_vm.userAgent && _vm.userAgent.updated_at) || "")
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "a-space",
            { staticClass: "ai-assistant__header__actions" },
            [
              _c(
                "a-tooltip",
                { attrs: { title: _vm.fullscreen ? "还原" : "全屏" } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "ai-assistant__header__action",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.triggerFullscreen.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: {
                          type: _vm.fullscreen
                            ? "fullscreen-exit"
                            : "fullscreen",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-layout-content",
        { ref: "content" },
        [
          _c("div", { staticClass: "ai-assistant-intro" }, [
            _c("div", { staticClass: "ai-assistant-intro__title" }, [
              _vm._v(
                "您好！我是" + _vm._s(_vm.userAgent && _vm.userAgent.agent_name)
              ),
            ]),
            _c("div", { staticClass: "ai-assistant-intro__desc" }, [
              _vm._v(_vm._s(_vm.userAgent && _vm.userAgent.agent_desc)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "ai-assistant-chats" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userAgent && _vm.userAgent.loading,
                      expression: "userAgent && userAgent.loading",
                    },
                  ],
                  staticClass: "ai-assistant-chat ai-assistant-chat--assistant",
                },
                [
                  _c("div", { staticClass: "ai-assistant-chats__loading" }, [
                    _c("div", {
                      staticClass: "ai-assistant-chats__loading-dot",
                    }),
                    _c("div", {
                      staticClass: "ai-assistant-chats__loading-dot",
                    }),
                    _c("div", {
                      staticClass: "ai-assistant-chats__loading-dot",
                    }),
                  ]),
                  _c("div", { staticClass: "ai-assistant-chat__content" }, [
                    _vm._v("思考中..."),
                  ]),
                ]
              ),
              _vm._l(
                (_vm.userAgent && _vm.userAgent.chats) || [],
                function (message, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: {
                        "ai-assistant-chat": true,
                        "ai-assistant-chat--user": message.source === 1,
                        "ai-assistant-chat--assistant": message.source === 2,
                      },
                    },
                    [
                      message.source === 3
                        ? _c("a-divider", [_vm._v("清除上下文")])
                        : _vm._e(),
                      message.source !== 3
                        ? _c(
                            "div",
                            { staticClass: "ai-assistant-chat__datetime" },
                            [_vm._v(_vm._s(message.created_at))]
                          )
                        : _vm._e(),
                      message.source !== 3
                        ? _c(
                            "div",
                            { staticClass: "ai-assistant-chat__content" },
                            [
                              message.think
                                ? _c("div", {
                                    staticClass: "ai-assistant-chat__think",
                                    domProps: {
                                      innerHTML: _vm._s(message.think),
                                    },
                                  })
                                : _vm._e(),
                              message.source === 1 ||
                              _vm.userAgent.agent_id === 2
                                ? _c("div", {
                                    staticClass: "ai-assistant-chat__html",
                                    domProps: {
                                      innerHTML: _vm._s(message.content),
                                    },
                                  })
                                : message.source === 2
                                ? _c("div", {
                                    staticClass: "ai-assistant-chat__markdown",
                                    domProps: {
                                      innerHTML: _vm._s(message.markdown),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      message.source === 2
                        ? _c(
                            "div",
                            { staticClass: "ai-assistant-chat__tools" },
                            [
                              _c(
                                "a-space",
                                [
                                  _c(
                                    "a-tooltip",
                                    { attrs: { title: "复制" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyText(
                                                message.content
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "copy" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-tooltip",
                                    { attrs: { title: "重新生成" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.reSend(message)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "redo" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
            ],
            2
          ),
          _vm.userAgent &&
          _vm.userAgent.chats &&
          _vm.userAgent.chats.length &&
          !_vm.userAgent.streaming &&
          !_vm.userAgent.loading &&
          _vm.userAgent.themes &&
          _vm.userAgent.themes.length
            ? _c("div", { staticClass: "ai-assistant-prompts-title" }, [
                _vm._v("您可能想看"),
              ])
            : _vm._e(),
          _vm.userAgent && !_vm.userAgent.streaming && !_vm.userAgent.loading
            ? _c(
                "a-space",
                {
                  staticClass: "ai-assistant-prompts",
                  attrs: { direction: "vertical", size: 12 },
                },
                _vm._l(
                  (_vm.userAgent && _vm.userAgent.themes) || [],
                  function (prompt, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "ai-assistant-prompts__item",
                        on: {
                          click: function ($event) {
                            return _vm.selectPrompt(prompt)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ai-assistant-prompts__title" },
                          [_vm._v(_vm._s(prompt.title))]
                        ),
                        _c("a-icon", { attrs: { type: "arrow-right" } }),
                      ],
                      1
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-layout-footer",
        [
          _c(
            "a-space",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "a-button",
                { attrs: { type: "default" }, on: { click: _vm.partition } },
                [_vm._v("清除上下文")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { ref: "textarea", staticClass: "ai-assistant__textarea" },
            [
              _c("a-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 6, maxRows: 8 },
                  disabled:
                    _vm.userAgent &&
                    (_vm.userAgent.streaming || _vm.userAgent.loading),
                },
                on: { keydown: _vm.handleSendMessage },
                model: {
                  value: _vm.inputValue,
                  callback: function ($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue",
                },
              }),
              _vm.userAgent && !_vm.userAgent.streaming
                ? _c(
                    "a-button",
                    {
                      staticClass: "ai-assistant__textarea__button",
                      attrs: {
                        type: "primary",
                        disabled: _vm.userAgent && _vm.userAgent.loading,
                      },
                      on: { click: _vm.sendMessage },
                    },
                    [_vm._v(" 发送 ")]
                  )
                : _c(
                    "a-button",
                    {
                      staticClass: "ai-assistant__textarea__button",
                      attrs: { type: "danger" },
                      on: { click: _vm.stopMessage },
                    },
                    [
                      _c("i", {
                        staticStyle: {
                          "margin-right": "4px",
                          display: "inline-block",
                          width: "11px",
                          height: "11px",
                          "background-color": "#fff",
                        },
                      }),
                      _vm._v("停止 "),
                    ]
                  ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "5px",
                "margin-bottom": "-5px",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _c(
                "span",
                { staticStyle: { color: "#0B1019", "font-size": "12px" } },
                [
                  _vm._v(
                    "剩余搜索量" +
                      _vm._s((_vm.quota && _vm.quota.daily_use_total) || "0") +
                      "/" +
                      _vm._s((_vm.quota && _vm.quota.daily_quota) || "10") +
                      "（限时免费，每日免费搜索量" +
                      _vm._s((_vm.quota && _vm.quota.daily_quota) || "10") +
                      "条）"
                  ),
                ]
              ),
              _c(
                "span",
                { staticStyle: { color: "#9199A7", "font-size": "10px" } },
                [_vm._v("所有内容均由AI生成,仅供参考")]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }